import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { OptionsService } from 'src/app/service/options.service';
import { Options } from 'src/app/model/options';
import { ElementsService } from 'src/app/service/elements.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-nav-button',
  templateUrl: './nav-button.component.html',
  styleUrls: ['./nav-button.component.less']
})
export class NavButtonComponent implements OnInit {
  subscription: any;
  options: Options[];
  nextOption: Options = null;
  prevOption: Options = null;
  currOption: Options = null;

  @ViewChild('warning') warningElement:ElementRef;
  
  constructor(
    private optionsService: OptionsService,
    private modalService: NgbModal,      
    private elementsService: ElementsService
    ) { }

  ngOnInit() {
    this.subscription = this.optionsService.options$.subscribe(data => {
      this.options = data;
      this.getOptions();
    });

  }

  setBackgroundModal(){
    this.modalService.open(this.warningElement, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  goNext(){
    if(this.elementsService.checkIfShapesClosed()){    
      if(this.nextOption)
        this.optionsService.change(this.nextOption.staticName,'active', true)
      else
        this.getOptions();
    }else{
      this.setBackgroundModal();
    }
  }

  goBack(){
    if(this.prevOption)
      this.optionsService.change(this.prevOption.staticName,'active',true);
    else
    this.getOptions();
  }

  getOptions(){
    this.currOption=this.optionsService.active;
    if(this.currOption){
      this.prevOption=this.optionsService.getPreviousOption(this.currOption.staticName);
      this.nextOption=this.optionsService.getNextOption(this.currOption.staticName)
    }
  }

}
